import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import * as fromRoot from '../../../../../../state/app.state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../shared/components';
import { ProjectsService } from '../../../../core/projects.service';

@Component({
    selector: 'app-issues-summary',
    templateUrl: './issues-summary.component.html',
    styleUrls: ['./issues-summary.component.scss'],
    standalone: false
})
export class IssuesSummaryComponent implements OnInit, OnDestroy {
  public initialized = false;
  public loading = 0;

  @Input() data: any;
  @Input() projectId = '';

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private dialog: MatDialog,
    private projectsService: ProjectsService,
  ) {
  }

  ngOnInit(): void {
  }

  redirectToProjectIssues(status: string): void {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();
    const doCloseAndNavigate = () => {
      this.projectsService.isAnyFormDirty.next(false);
      this.projectsService.closeRightPanel.next();
      // The project's Issues tab, like the RFIs tab. "open" is the tab's
      // default filter (every open status on a workflow project), so it is
      // left to the tab.
      this.router.navigate(['/projects', this.projectId], {
        queryParams: { tab: 'issues', ...(status === 'open' ? {} : { status }) },
      });
    };
    if (!isFormDirty) {
      doCloseAndNavigate();
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Unsaved changes',
        'There are unsaved changes.<br/>Are you sure you want to discard?',
      ),
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        doCloseAndNavigate();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
